// extracted by mini-css-extract-plugin
export default {"testimony":"styles_testimony__jr2-e","overlay":"styles_overlay__imGyk","icon":"styles_icon__B1viV"};